export default "It's a continual tax that is paid based on the self-assessed value of an asset.\n";